import { render } from "./BayerProfile.vue?vue&type=template&id=94ceb520&scoped=true"
import script from "./BayerProfile.vue?vue&type=script&lang=js"
export * from "./BayerProfile.vue?vue&type=script&lang=js"

import "./BayerProfile.vue?vue&type=style&index=0&id=94ceb520&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94ceb520"]])

export default __exports__